/**
 * Block: news-cards, script.
 *
 * Enqueued in editor and front end.
 */

import Swiper, { Mousewheel } from 'swiper';

function init() {

	const swiper = new Swiper( '.wp-block-lakecountyohio-news-cards__slider', {
		modules: [ Mousewheel ],
		slidesPerView: 'auto',
		mousewheel: {
			releaseOnEdges: true,
		},
		spaceBetween: 16,
		slidesOffsetBefore: 16,
		slidesOffsetAfter: 16,
	} );


	
}

document.addEventListener('DOMContentLoaded', () => {
	if ( window.acf ) {
		window.acf.addAction( 'render_block_preview/type=lakecountyohio/news-cards', init );
	}
	else {
		init();
	}
});
